import axios from 'axios';
import _groupBy from 'lodash/groupBy';
import Storage from '@homeservices/tool-kit/storage/local-storage';

const UPDATES_LAST_SEEN_TIME = 'TIME_LAST_SEEN';
const sortWhatsNew = (items) => {
  const sortedItems = items.sort((a, b) =>
    (new Date(b.date) - new Date(a.date)));
  const latest = sortedItems.splice(0, 3);
  const groupedWhatsNewItems = _groupBy(
    sortedItems,
    item => item.date.substring(0, 7)
  );
  groupedWhatsNewItems.latest = latest;
  return groupedWhatsNewItems;
};
export default {
  namespaced: true,
  state () {
    return {
      whatsNewList: {},
      searchTerm: '',
      timeUpdateSeen: null,
    };
  },
  getters: {
    whatsNewList (state) {
      return state.whatsNewList;
    },
    searchTerm (state) {
      return state.searchTerm;
    },
    timeUpdateSeen (state) {
      return state.timeUpdateSeen;
    },
    groupedWhatsNewItems (state) {
      if (Object.keys(state.whatsNewList).length > 0) {
        const items = state.whatsNewList.itemList.map(item => item);
        return sortWhatsNew(items);
      }
      return null;
    },
    groupedWhatsNewSearch (state) {
      if (state.whatsNewList) {
        const items = state.whatsNewList.itemList.map(item => item);
        const searchItems = items.filter(({ content, title }) => {
          return content.toLowerCase().includes(state.searchTerm.toLowerCase())
            || title.toLowerCase().includes(state.searchTerm.toLowerCase());
        });
        return sortWhatsNew(searchItems);
      }
      return null;
    },
  },
  actions: {
    async fetchWhatsNewList ({ commit, dispatch, rootGetters, rootState }) {
      await dispatch('account/pro/info/fetchUserAddresses', null, { root: true });
      const currentProIds = Object.keys(rootState.account.pro.serviceCatalogOccupations);
      const [serviceProviderId] = rootGetters['account/pro/serviceProvidersIds'];
      const zipcode = rootGetters['account/pro/info/zipcode'];
      const { data } = await axios.get('/api/contentful/whatsnew');

      if (Object.keys(data.itemList).length > 0) {
        const items = {};
        items.title = data.title;
        items.itemList = data.itemList.filter((item) => {
          if (item.expireDate === '') {
            return true;
          }
          return new Date().getTime() <= new Date(item.expireDate).getTime();
        }).filter((occItem) => {
          if (occItem.occupationIds) {
            const filteredOccIds = occItem.occupationIds.split(',');
            return currentProIds.some(pId => filteredOccIds.includes(pId));
          }
          return true;
        }).filter((proIdItem) => {
          if (proIdItem.proIds) {
            const filteredProIds = proIdItem.proIds.split(',');
            return filteredProIds.includes(serviceProviderId);
          }
          return true;
        }).filter((zipItem) => {
          if (zipItem.zipCodes) {
            const filteredZipCodes = zipItem.zipCodes.split(',');
            return filteredZipCodes.includes(zipcode);
          }
          return true;
        });
        commit('setWhatsNewList', items);
      }
    },
    storeTimeUpdateSeen ({ dispatch }) {
      Storage.set(UPDATES_LAST_SEEN_TIME, { time: new Date() });
      dispatch('fetchTimeUpdateSeen');
    },
    fetchTimeUpdateSeen ({ commit }) {
      const { time } = Storage.get(UPDATES_LAST_SEEN_TIME);
      commit('setTimeUpdateSeen', time);
    },
  },
  mutations: {
    setWhatsNewList (state, data) {
      state.whatsNewList = data;
    },
    resetWhatsNewList (state) {
      state.whatsNewList = {};
    },
    setSearchTerm (state, { searchTerm }) {
      state.searchTerm = searchTerm;
    },
    resetSearchTerm (state) {
      state.searchTerm = null;
    },
    setTimeUpdateSeen (state, time) {
      state.timeUpdateSeen = time;
    },
    resetTimeUpdateSeen (state) {
      state.timeUpdateSeen = null;
    },
  },
};
